import {axios} from 'api/api';

export default class ProductFeaturesApi {
  static baseUrl = '/productFeatures';

  static getAll(config = {}) {
    return axios.get(this.baseUrl, config);
  }
}
